<template>
    <div :class="`rating-scale rating-scale-align-${align}`">
        <label for="rating">{{ fieldLabel }}</label>
        <div class="scale">
            <div @click="setRating(1)" :class="{ rated: rating === 1 }" class="circle">
                <span>1</span>
                <p>{{ subLabelOne }}</p>
            </div>
            <div @click="setRating(2)" :class="{ rated: rating === 2 }" class="circle">
                <span>2</span>
            </div>
            <div @click="setRating(3)" :class="{ rated: rating === 3 }" class="circle">
                <span>3</span>
            </div>
            <div @click="setRating(4)" :class="{ rated: rating === 4 }" class="circle">
                <span>4</span>
            </div>
            <div @click="setRating(5)" :class="{ rated: rating === 5 }" class="circle">
                <span>5</span>
                <p>{{ subLabelTwo }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormRatingScale",
    props: {
        fieldLabel: {
            type: String,
            required: true,
        },
        align: {
            type: String,
            required: true,
        },
        subLabelOne: {
            type: String,
            required: true,
        },
        subLabelTwo: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            default: () => ({ rating: 0 })
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            rating: this.value.rating,
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.rating = newValue.rating;
            },
            deep: true
        }
    },
    methods: {
        setRating(value) {
            this.rating = value;
            this.emitValues();
        },
        emitValues() {
            this.$emit("input", {
                rating: this.rating,
                fieldLabel: this.fieldLabel,
                subLabelOne: this.subLabelOne,
                subLabelTwo: this.subLabelTwo
            });
        }
    },
    mounted() {
        this.emitValues();
    }
};
</script>

<style lang="scss" scoped>
.rating-scale-align-left {
    display: flex !important;
    align-items: center;
    padding: 10px;

    > label {
        font-size: 14px !important;
        width: 150px;
    }

    .scale {
        width: 100% !important;
    }
}

.rating-scale-align-right {
    display: flex !important;
    align-items: center;
    padding: 10px;

    > label {
        font-size: 14px !important;
        width: 150px;
        text-align: right;
        margin-right: 5px;
    }

    .scale {
        width: 100% !important;
    }
}

.rating-scale {
    width: 100%;
    max-width: 600px;
    margin: 10px auto;
    text-align: left;

    > label {
        display: block;
        font-size: 18px;
        font-weight: normal;
        margin-bottom: 5px;
        color: #2c3e50;
    }

    .scale {
        display: flex;
        justify-content: space-between;
        gap: 8px;

        .circle {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 50px;
            border: 1px solid #ccd6dd;
            border-radius: 50%;
            cursor: pointer;
            transition: all 0.3s ease;

            span {
                font-size: 16px;
                color: #2c3e50;
            }

            p {
                font-size: 10px;
                color: #8696a0;
                margin-top: 80px;
                position: absolute;
            }

            &.rated {
                border-color: #3b82f6;
                background-color: #3b82f6;

                span {
                    color: #ffffff;
                }

                p {
                    color: #3b82f6;
                }
            }
        }
    }
}
</style>